import React from 'react';
import { Link, Skeleton, Typography } from '@mui/material';
import { Link as RouterLink, useNavigation } from 'react-router-dom';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { paths } from '@/app/routes';

export const DataGridAuditDealName = ({ dealId }) => {
	const navigation = useNavigation();
	const { data: dealRow, isLoading } = useGetDealRowQuery(dealId, {
		skip: !dealId,
	});

	if (!dealId) {
		return (
			<Typography variant='body2' color='text.secondary'>
				—
			</Typography>
		);
	}

	if (isLoading) {
		return <Skeleton variant='text' width='8em' />;
	}

	const dealLink = `${paths.deals}/${dealId}`;
	const name = dealRow?.dealName ?? dealId;
	const isLoadingDeal =
		navigation.state === 'loading' && navigation?.location?.pathname?.includes(dealId);

	return (
		<Link
			to={dealLink}
			component={RouterLink}
			underline='hover'
			sx={{ textDecorationLine: 'none', width: '100%' }}
		>
			<Typography
				sx={(theme) => ({
					color: isLoadingDeal ? theme.palette.folioPurpleAccent : theme.palette.primary.main,
					fontWeight: 600,
					'&:hover': {
						textDecoration: 'underline',
					},
				})}
			>
				{name}
			</Typography>
		</Link>
	);
};
